import { GlobalService } from '@23degrees/shared/services/global/global.service';
import { inject } from '@angular/core';
import { HttpRequest, HttpEvent, HttpInterceptorFn, HttpHandlerFn } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthQuery } from '@23degrees/stores/auth/auth.query';
import { ANON_USER } from '@23degrees/shared-code/config/permissions';


export const jwtInterceptor: HttpInterceptorFn = (
  request: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
  const authQuery: AuthQuery = inject(AuthQuery);
  const globalService: GlobalService = inject(GlobalService);

  let token: string;
  const url = request.url;

  // USE TO DEBUG URL STUFF
  // console.log('[HTTP Request]', url);
  if (url.indexOf('http://') === -1 && url.indexOf('https://') === -1) {
    try {
      if (authQuery) {
        token = authQuery.token();
      }
    } catch (error) {
      console.log('bad coding ahead', error);
    }

    const noAuth = request.headers.has('NoAuth');
    if (noAuth) {
      const headers = request.headers.delete('NoAuth');
      request = request.clone({ headers });
    }

    if (token && !noAuth) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
    }

    if (globalService.isServer() && !noAuth) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${ANON_USER.token}`,
          injecteduser: `{"_id": "${ANON_USER.id}" }`,
        },
      });
    }
  } 
  else if (globalService.isServer()) {
    request = request.clone({
      setHeaders: {
        Authorization: `Bearer ${ANON_USER.token}`,
        injecteduser: `{"_id": "${ANON_USER.id}" }`,
      },
    });
  }

  return next(request);

};